import Vue from "vue";
import VueRouter from "vue-router";

import Home from "./components/Home";
import Main from "./components/Dashboard/Main";
import Login from "./components/Login";
import GA from "./components/Ga";
import ResetPassword from "./components/ResetPassword";

import Blacklist from "./components/Blacklist/blacklist";
import RafflePage from "./components/RafflePage/RafflePage";

import BonusRequest from "./components/Bonus/BonusRequest";
import BonusRequestList from "./components/Bonus/BonusRequestList";
import BonusRequestDetail from "./components/Bonus/BonusRequestDetail";

import GsmNewCustomerReport from "./components/Report/GsmNewCustomerReport";
import GsmOldCustomerReport from "./components/Report/GsmNewCustomerReport";
import ComplaintReport from "./components/Report/ComplaintReport";
import ScratchReport from "./components/Report/ScratchReport";
import PassionFlowerReport from "./components/Report/PassionFlowerReport";

import User from "./components/User/User";
import UserList from "./components/User/UserList";
import UserAuthority from "./components/User/UserAuthority";

import Department from "./components/Department/Department";
import DepartmentList from "./components/Department/DepartmentList";
import DepartmentAuthority from "./components/Department/DepartmentAuthority";

import App from "./components/App/App";
import AppList from "./components/App/AppList";
import AppUser from "./components/App/AppUser";

import Watch from "./components/Watch/Watch";
import WatchList from "./components/Watch/WatchList";
import WatchLog from "./components/Watch/WatchLog";

import CustomerSearch from "./components/Customer/CustomerSearch";
import CustomerNotFound from "./components/Customer/NotFound";
import CustomerMain from "./components/Customer/Main";
import CustomerDetail from "./components/Customer/CustomerDetail";
import CustomerSummary from "./components/Customer/CustomerSummary";
import CustomerDepositControl from "./components/Customer/CustomerDepositControl";
import CustomerBonus from "./components/Customer/CustomerBonus";
import CustomerPromotion from "./components/Customer/CustomerPromotion";
import CustomerSuspend from "./components/Customer/CustomerSuspend";
import CustomerFinance from "./components/Customer/CustomerFinance";
import CustomerPassionflower from "./components/Customer/CustomerPassionflower";
import CustomerScratch from "./components/Customer/CustomerScratch";
import CustomerGsmNewCustomer from "./components/Customer/CustomerGsmNewCustomer";

import IpWhitelist from './components/IpWhitelist/IpWhitelist'

import ManualBonusReport from "./components/Report/ManualBonusReport";
import UserLogsList from "./components/UserLogs/UserLogsList";
import ChangepasswordList from "./components/UserLogs/ChangepasswordList";
import NormalUserList from "./components/UserLogs/UserList";
import ipWhiteList from "./components/User/ipWhiteList";
import InsiyatifSearch from "./components/Insiyatif/Insiyatif";
import InsiyatifMain from "./components/Insiyatif/InsiyatifMain";
import InsiyatifReport from "./components/Insiyatif/InsiyatifReport";
import UserSetting from "./components/UserProfile/UserSetting";
// import UserBonuses from "./components/UserProfile/UserBonuses";
// import UserDeposits from "./components/UserProfile/UserDeposits";
// import UserWithdraws from "./components/UserProfile/UserWithdraws";
// import UserStatistics from "./components/UserProfile/UserStatistics";
//**bonuslar */
import Bonus from "./components/BonusList/Bonus";
import BonusList from "./components/BonusList/BonusList";
import BonusSettings from "./components/BonusList/BonusSettings";
import BonusInfo from "./components/BonusList/BonusTabs/BonusInfo";
import CustomerConnections from "./components/BonusList/BonusTabs/CustomerConnections";
import BonusOddsSettings from "./components/BonusList/BonusTabs/BonusOddsSettings";
import { store } from "./store/store";
import OrderTrackingReport from "./components/OrderTrackingReport/PanelFrontOrderTrackingReport";

const routes = [
  {
    path: "/",
    component: Home,
    children: [
      { path: "", component: Main },
      { path: "/dashboard", component: Main },
      {
        path: "/insiyatif-search",
        component: InsiyatifSearch,
        children: [
          { path: "/", component: InsiyatifMain },
          { path: ":id", component: InsiyatifReport }
        ]
      },
      {
        path: "/bonus-requests",
        component: BonusRequest,
        children: [
          { path: "/", component: BonusRequestList },
          { path: ":id", component: BonusRequestDetail }
        ]
      },
      {
        path: "/manual-bonus-report",
        component: ManualBonusReport,
        meta: { requiresAuth: true }
      },

      { path: "/gsm-new-customer-requests", component: GsmNewCustomerReport },
      { path: "/complaint-report", component: ComplaintReport },
      { path: "/scratch-report", component: ScratchReport },
      { path: "/passion-flower-report", component: PassionFlowerReport },
      { path: "/ipwhitelist", component: IpWhitelist, meta: {requiresAuth: true} },
      {
        path: '/pages/profile',
        name: 'userprofile',
        component: UserSetting,
        meta: {
          title: "Müşteri Bilgisi",
          requiresAuth: true
        },
      },
      {
        path: "/users",
        component: User,
        children: [
          { path: "/", component: UserList },
          { path: "authority/:id", component: UserAuthority }
        ]
      },
      { path: "/blacklist", component: Blacklist },
      { path: "/raffle_page", component: RafflePage },

      { path: "/panelfront-tracking-report", component: OrderTrackingReport },
      {
        path: "/departments",
        component: Department,
        children: [
          { path: "/", component: DepartmentList },
          { path: "authority/:id", component: DepartmentAuthority }
        ]
      },
      { path: "/user-logs-list", component: UserLogsList },
      { path: "/Change-password-List", component: ChangepasswordList },
      { path: "/Normal-User-List", component: NormalUserList },
      {
        path: "/apps",
        component: App,
        children: [
          { path: "/", component: AppList },
          { path: "users/:id", component: AppUser }
        ]
      },
      {
        path: "/watch",
        component: Watch,
        children: [
          { path: "/", component: WatchList },
          { path: "logs/:id", component: WatchLog }
        ]
      },
      {
        path: "/bonus-list",
        component: Bonus,
        children: [
          { path: "/", component: BonusList },
          {
            path: "settings",
            component: BonusSettings,
            children: [
              { path: "info/:id", component: BonusInfo },
              {
                path: "customer-connections/:id",
                component: CustomerConnections
              },
              { path: "bonus-odds/:id", component: BonusOddsSettings }
            ]
          }
        ]
      },
      {
        path: "/customer-search",
        component: CustomerSearch,
        children: [
          { path: "/", component: CustomerMain },
          { path: "not-found", component: CustomerNotFound },
          {
            path: "detail",
            component: CustomerDetail,
            children: [
              { path: "/", component: CustomerSummary },
              { path: "deposit-control", component: CustomerDepositControl },
              { path: "bonuses", component: CustomerBonus },
              { path: "promotions", component: CustomerPromotion },
              { path: "suspend", component: CustomerSuspend },
              { path: "finance", component: CustomerFinance },
              { path: "passion-flower", component: CustomerPassionflower },
              { path: "scratch", component: CustomerScratch },

              { path: "gsm-new-customer", component: CustomerGsmNewCustomer }
            ]
          },
          { path: ":id", component: CustomerMain }
        ]
      }
    ],
    beforeEnter(to, from, next) {
      if (store.getters.isGa) {
        next();
      } else {
        if (!store.getters.isAuthenticated) {
          if (window.location.hash != "#/login") next("/login");
        } else {
          if (window.location.hash != "#/ga") next("/ga");
        }
      }
    }
  },
  {
    path: "/login",
    component: Login,
    beforeEnter(to, from, next) {
      if (store.getters.isAuthenticated) {
        next("/ga");
      } else {
        next();
      }
    }
  },
  {
    path: "/reset-password",
    component: ResetPassword,
    beforeEnter(to, from, next) {
      if (!store.getters.getAccountStatus) next("/login");
      else next();
    }
  },
  {
    path: "/ga",
    component: GA,
    beforeEnter(to, from, next) {
      if (store.getters.isGa) next("/");
      else if (!store.getters.isAuthenticated) next("/login");
      else next();
    }
  }
];

Vue.use(VueRouter);

export const router = new VueRouter({
  routes
});



// WEBPACK FOOTER //
// ./src/routes.js